<template lang="pug">
  sweet-modal(
    ref="tutorial"
    :title="title"
  )
    .tut-modal
      .tut-modal__container(
        v-if="currentStep !== null"
      )
        // template
          strong Current step
          br
          span {{ currentStep }}
          br
          strong Next Step
          br
          span {{ nextStep }}
        slot
        template(v-if="!force")
          hr
          .tut-modal__footer
            span.text-link.tut-modal__skip(
              v-on:click="onClickSkip"
            ) Скрыть подсказки
            span.tut-modal__counter
              strong {{ passedSteps }} 
              | / {{ totalSteps }}
            template(v-if="nextStep !== undefined")
              router-link.btn.tut-modal__btn-next(:to="nextRoute") Вперед
            template(v-else)
              .btn.tut-modal__btn-next(
                v-on:click="close"
              ) Завершить
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '@/eventBus';

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      currentStep: undefined,
      nextStep: undefined,
      force: false
    };
  },

  computed: {
    ...mapState({
      isAdmin: state => state.user.profile.isAdmin,
      tutorialComplete: state => state.tutorial.isComplete
    }),

    totalSteps() {
      return this.$store.getters.getTutorialStepsCount;
    },

    passedSteps() {
      return this.$store.getters.getTutorialStepsPassed;
    },

    nextRoute() {
      const nextRoute = {
        name: this.nextStep.route
      };
      if (this.nextStep.constructorId !== undefined) {
        nextRoute.params = {
          constructorId: this.nextStep.constructorId
        };
      }
      console.log(nextRoute);
      return nextRoute;
    }
  },

  methods: {
    open(step) {
      this.$store.dispatch('completeTutorialStepById', step.id);
      this.currentStep = step;
      this.nextStep = this.$store.getters.getTutorialNextStep;
      if (this.nextStep === undefined) this.$store.dispatch('completeTutorial');
      this.$refs.tutorial.open();
    },

    close() {
      this.$refs.tutorial.close();
    },

    onClickSkip() {
      this.$store.dispatch('completeTutorial');
      this.close();
    }
  },

  mounted() {
    if (this.isAdmin || this.tutorialComplete || this.force) return;
    const step = this.$store.getters.getTutorialStepByRoute(this.$route.name);
    if (step !== undefined) {
      if (!step.isComplete) {
        this.open(step);
      }
    }
  },

  created() {
    EventBus.$on('OPENTUTORIAL', stepId => {
      if (this.$refs.tutorial !== undefined) {
        this.force = true;
        this.open(stepId);
      }
    });
  },

  beforeDestroy() {
    this.close();
  }
};
</script>

<style lang="scss" scoped>
.tut-modal {
  text-align: left;

  &__footer {
    display: flex;
    align-items: center;
    // justify-content: flex-end;
    flex-shrink: 0;
  }

  &__skip {
    width: 100%;
    display: block;
  }

  &__counter {
    flex-shrink: 0;
    display: block;
    margin-right: 10px;
  }

  &__btn-next {
    margin: 0;
  }
}
</style>
